export default __webpack_public_path__ + "static/media/logo_kompas.33a4b4f4.png";